import React from 'react';
import './CardHeaderActions.scss';
import { headerActionComponents } from 'components/actionsIndex';

export interface HeaderActions {
  actions: string[];
  response?: any;
  ruleName?: string;
}

const CardHeaderActions: React.FC<HeaderActions> = ({ actions, response, ruleName }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        {actions?.length ? (
          <>
            {actions?.map((item: any, i: number) => {
              if (headerActionComponents[item]) {
                // Only render SWITCH_CHART_TABLE for widgets with RuleName = OneQuestionOneCalculation
                if (item === 'SWITCH_LINECHART_TABLE') {
                  if (ruleName !== 'OneQuestionOneCalculation') {
                    return null;
                  }
                }
                const ActionComponent = headerActionComponents[item];
                if (item === 'EXPORT_TO_CSV') {
                  // Skip rendering ExportToFile here, will render separately
                  return null;
                }
                return <ActionComponent key={i} response={response} />;
              }
            })}
          </>
        ) : null}
      </div>
      {/* Render ExportToFile (meatball menu) at the right */}
      {actions?.includes('EXPORT_TO_CSV') && headerActionComponents['EXPORT_TO_CSV'] ? (
        <div className="header-action-export-to-file">
          {(() => {
            const ExportToFile = headerActionComponents['EXPORT_TO_CSV'];
            return <ExportToFile response={response} />;
          })()}
        </div>
      ) : null}
    </div>
  );
};

export default CardHeaderActions;
